SupportViewVoucherServiceActionView = require('./service_actions/view_voucher_service_action')
SupportCancelOrderServiceActionView = require('./service_actions/cancel_order_service_action')
SupportEditOrderServiceActionView = require('./service_actions/edit_order_service_action')
SupportGiftOrderServiceActionView = require('./service_actions/gift_order_service_action')
SupportUpdateShippingServiceActionView = require('./service_actions/update_shipping_address_service_action')
SupportTrackOrderServiceActionView = require('./service_actions/track_order_service_action')
SupportRedemptionInstructionsServiceActionView = require('./service_actions/redemption_instructions_service_action')
SupportReturnItemsServiceActionView = require('./service_actions/return_item_service_action')
SupportCancelReservationsServiceActionView = require('./service_actions/cancel_reservations_service_action')
SupportEditGiftServiceActionView = require('./service_actions/edit_gift_service_action')
SupportViewOrderDetailsServiceActionView = require('./service_actions/view_order_details_service_action')
SupportPrintGiftCardVoucherServiceActionView = require('./service_actions/print_gift_card_voucher_service_action')
SupportFinePrintServiceActionView = require('./service_actions/fine_print_service_action')
SupportOrderFoodServiceActionView = require('./service_actions/order_food_service_action')
SupportServiceActionsBaseView = require('./service_actions/service_action_base')
Backbone = require 'backbone'
Backbone.$ = $

class SupportServiceActionMainView extends Backbone.View
  id: 'serviceActionContainer'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @serviceActions = Groupon.Support.currentOrder.serviceActions || []
    @constructButtonInfo()
    @mapViews()

  constructButtonInfo: () ->
    if @options.showLinksAndButtons
      @secondaryButtons = ['cancel_reservations', 'view_voucher', 'order_food', 'track_order', 'edit_order', 'cancel_order', 'update_shipping', 'return_item']
      @linkButtons = ['view_order_details', 'edit_gift', 'gift_to_friend', 'redemption_instructions', 'print_gift_card_voucher', 'fine_print']
      @defaultButtons = []
    else if @options.showOnlyLinks
      @secondaryButtons = []
      @linkButtons = [
        'cancel_reservations', 'view_voucher', 'order_food', 'track_order', 'edit_order', 'cancel_order', 'update_shipping', 'return_item',
        'view_order_details', 'edit_gift', 'gift_to_friend', 'redemption_instructions', 'print_gift_card_voucher', 'fine_print'
      ]
      @defaultButtons = []
    else
      @secondaryButtons = []
      @linkButtons = []
      @defaultButtons = [
        'cancel_reservations', 'view_voucher', 'order_food', 'track_order', 'edit_order', 'cancel_order', 'update_shipping', 'return_item',
        'view_order_details', 'edit_gift', 'gift_to_friend', 'redemption_instructions', 'print_gift_card_voucher', 'fine_print'
      ]

  getButtonType: (serviceActionName) ->
    if _.contains(@secondaryButtons, serviceActionName)
      @secondaryButtonIdentifier()
    else if _.contains(@linkButtons, serviceActionName)
      @linkIdentifier()
    else
      @defaultButtonIdentifier()

  linkIdentifier: () ->
    SupportServiceActionsBaseView::linkIdentifier()

  defaultButtonIdentifier: () ->
    SupportServiceActionsBaseView::defaultButtonIdentifier()

  secondaryButtonIdentifier: () ->
    SupportServiceActionsBaseView::secondaryButtonIdentifier()

  mapViews: ->
    @map = {}
    @map.view_order_details =
      view: SupportViewOrderDetailsServiceActionView
      button_type: @getButtonType('view_order_details')
    @map.edit_gift =
      view: SupportEditGiftServiceActionView
      button_type: @getButtonType('edit_gift')
    @map.cancel_reservations =
      view: SupportCancelReservationsServiceActionView
      button_type: @getButtonType('cancel_reservations')
    @map.view_voucher =
      view: SupportViewVoucherServiceActionView
      button_type: @getButtonType('view_voucher')
    @map.gift_to_friend =
      view: SupportGiftOrderServiceActionView
      button_type: @getButtonType('gift_to_friend')
    @map.redemption_instructions =
      view: SupportRedemptionInstructionsServiceActionView
      button_type: @getButtonType('redemption_instructions')
    @map.track_order =
      view: SupportTrackOrderServiceActionView
      button_type: @getButtonType('track_order')
    @map.edit_order =
      view: SupportEditOrderServiceActionView
      button_type: @getButtonType('edit_order')
    @map.cancel_order =
      view: SupportCancelOrderServiceActionView
      button_type: @getButtonType('cancel_order')
    @map.update_shipping =
      view: SupportUpdateShippingServiceActionView
      button_type: @getButtonType('update_shipping')
    @map.return_item =
      view: SupportReturnItemsServiceActionView
      button_type: @getButtonType('return_item')
    @map.print_gift_card_voucher =
      view: SupportPrintGiftCardVoucherServiceActionView
      button_type: @getButtonType('print_gift_card_voucher')
    @map.fine_print =
      view: SupportFinePrintServiceActionView
      button_type: @getButtonType('fine_print')
    @map.order_food =
      view: SupportOrderFoodServiceActionView
      button_type: @getButtonType('order_food')

  render: ->
    @$el.attr('data-bhw', 'servicActions')
    for serviceAction in @serviceActions
      action = @map[serviceAction]
      if action?.view?
        view = new action.view()
        view.setButtonType(action.button_type)
        view.render()
        view.$el.addClass('service-action-item').addClass(view.button_type)
        @$el.append(view.el)

module.exports = SupportServiceActionMainView
